const didOnlyEntitlements = ['numE911DIDs', 'numLocalDIDs', 'numTollFreeDIDs'];
export default didOnlyEntitlements;
